import { render, staticRenderFns } from "./InviteUser.vue?vue&type=template&id=409f25c1&scoped=true&"
import script from "./InviteUser.vue?vue&type=script&lang=js&"
export * from "./InviteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409f25c1",
  null
  
)

export default component.exports